
import { useState, useEffect } from 'react';
import StartScreen from './components/StartScreen';
import UsernameInput from './components/UsernameInput';
import ScanningAnimation from './components/ScanningAnimation';
import ResultScreen from './components/ResultScreen';

export default function Home() {
  const [step, setStep] = useState<'start' | 'input' | 'scanning' | 'result'>('start');
  const [username, setUsername] = useState('');
  const [userCount, setUserCount] = useState(0);

  useEffect(() => {
    const count = Math.floor(Math.random() * 500) + 1200;
    setUserCount(count);
  }, []);

  const handleStart = () => {
    setStep('input');
  };

  const handleUsernameSubmit = (name: string) => {
    setUsername(name);
    setStep('scanning');
  };

  const handleScanComplete = () => {
    setStep('result');
  };

  const handleOpenBot = () => {
    window.open('https://t.me/your_bot_username', '_blank');
  };

  return (
    <div className="min-h-screen bg-[#0f0f0f] overflow-hidden">
      <div className="max-w-md mx-auto min-h-screen flex flex-col">
        {step === 'start' && (
          <StartScreen onStart={handleStart} userCount={userCount} />
        )}
        {step === 'input' && (
          <UsernameInput onSubmit={handleUsernameSubmit} />
        )}
        {step === 'scanning' && (
          <ScanningAnimation username={username} onComplete={handleScanComplete} />
        )}
        {step === 'result' && (
          <ResultScreen onOpenBot={handleOpenBot} />
        )}
      </div>
    </div>
  );
}
